import { render, staticRenderFns } from "./GeneralSettingContactAddressCity.vue?vue&type=template&id=0af67e26&"
import script from "./GeneralSettingContactAddressCity.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports